import React from "react";
import PropTypes from "prop-types";
import MinusIcon from "views/components/icons/MinusIcon";
import PlusIcon from "views/components/icons/PlusIcon";

import style from "./style.module.css";

const Accordion = ({ label, expanded, onClick, children, className }) => {
  return (
    <div className={style.wrapper}>
      <div className={style.labelWrapper} onClick={onClick}>
        <div className={style.label}>{label}</div>
        <div className={style.icon}>
          {expanded ? <MinusIcon size="12" /> : <PlusIcon size="12" />}
        </div>
      </div>
      {expanded && <div className={style.content}>{children}</div>}
    </div>
  );
};

Accordion.propTypes = {
  label: PropTypes.string.isRequired,
  expanded: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
  children: PropTypes.element
};

export default Accordion;
